import React from "react"

import { Typography } from "@synapse-analytics/synapse-ui"

import { MonacoTextEditor } from "./MonacoTextEditor"
import type { Props as MonacoTextEditorProps } from "./MonacoTextEditor"

import styles from "./KonanEditor.module.scss"

type Props = {
  title: string
  value: object | string
} & Omit<MonacoTextEditorProps, "value">

/**
 * A text editor component that displays JSON data in a Monaco editor
 * but with extra styles
 * This component provides a consistent interface for displaying structured data
 * with a title header and formatted JSON content.
 *
 * @param Props - The component props
 * @returns A React element containing the text editor with header and body
 *
 */
export function KonanTextEditor({ title, value, ...monacoProps }: Props): React.ReactElement {
  return (
    <div className={styles.editorContainer}>
      <div className={styles.editorHeader}>
        <Typography variant="p" className={styles.editorTitle}>
          {title}
        </Typography>
      </div>

      <div className={styles.editorBody}>
        <MonacoTextEditor
          {...monacoProps}
          value={JSON.stringify(value ?? {}, null, 2)}
          language={monacoProps.language ?? "json"}
          height={monacoProps.height ?? "100%"}
          readOnly={monacoProps.readOnly ?? true}
          enableCopy={monacoProps.enableCopy ?? true}
        />
      </div>
    </div>
  )
}
